exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "p[data-v-6ca41894] {\n  font-weight: 700;\n  display: inline-block;\n  margin: 0;\n}\n", ""]);

// exports
